import { PersonalDisasterAppState } from 'src/store';
import { StandardAppConfig } from 'src/Components/Configuration/StandardAppConfig';
import { HasMessage } from '../EligibilityPageProjectArchetype';
import { checkAddressAndSource, checkInList, checkRequired, PageValidatorContext } from '../../Validators';

export const PersonalDisasterValidator = (
    globalState: PersonalDisasterAppState,
    appConfig: StandardAppConfig
): Record<string,HasMessage> => {
    const errorSummary : Record<string,HasMessage> = {};
    const { eligibility, profileConnectInfo } = globalState;
    const context: PageValidatorContext = {
        appConfig: appConfig,
        formObject: eligibility,
        errorSummary: errorSummary,
        pageName: 'eligibilityPage'
    };

    checkRequired(context, 'ownerOrRenter');
    if (eligibility.ownerOrRenter === 'owner') {
        checkRequired(context, 'ownerOccupierOrInvestor');
    } else if (eligibility.ownerOrRenter === 'renter') {
        checkRequired(context, 'peopleLivingAtAddress');
    }
    if (checkRequired(context, 'insurance')) {
        checkInList(context, 'insurance',['not insured']);
    }
    checkAddressAndSource(context, profileConnectInfo.residentialAddress);

    return errorSummary;
};
